import styled from 'styled-components';
import NavItemWrapper from './NavItem';
import links from './links/links';

const NavListOnlyDesktop = styled.ul`
  @media screen and (max-width: 1000px) {
    display: none;
  }
  list-style: none;
  margin-top: 0px;
  padding-left: 0;
`;

function SidebarNavDesktop() {
  return (
    <NavListOnlyDesktop>
      {links.map((link: { path: string; name: string }, index: number) => (
        <NavItemWrapper key={index} path={link.path} name={link.name} exact />
      ))}
    </NavListOnlyDesktop>
  );
}

export default SidebarNavDesktop;
